import React from 'react';
import SubMegaMenu from '../SubMegaMenu';
import FooterItems from '../FooterItems';

import { DetailedSubMenuContainer } from './styles';

const DetailedSubMenu = ({ isMenuOpened, setMobileMenuOpened, subNavElements = [] }) => {
  const groups = [...new Set(subNavElements.filter(ele => ele.group).map(ele => ele.group.group))];

  const filteredNavElements = groups.reduce((prev, cur) => {
    const ret = { ...prev };
    ret[cur] = subNavElements.filter(ele => ele?.group?.group === cur);
    return ret;
  }, {});

  return (
    <DetailedSubMenuContainer
      data-testid="detailed-sub-menu"
      className="mega-menu"
      isMenuOpened={isMenuOpened}
    >
      {Object.keys(filteredNavElements).map((group, index) => {
        return (
          group !== 'Footer' && (
            <SubMegaMenu
              key={index}
              groupLabel={group}
              navItems={filteredNavElements[group]}
              index={index}
              hasSeeAllElement={filteredNavElements.Footer}
              setMobileMenuOpened={setMobileMenuOpened}
              isProProducts={group === 'Pro Products'}
            />
          )
        );
      })}
      {filteredNavElements.Footer && (
        <div className="mega-menu--footer">
          <FooterItems groups={groups} filteredNavElements={filteredNavElements} />
        </div>
      )}
    </DetailedSubMenuContainer>
  );
};

export default DetailedSubMenu;
